import { CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import useConfig from 'hooks/useConfig';
import {
    useGetApiUserPreferencesParsedQuery,
    usePutApiUserPreferencesMutation,
} from 'store/userOrg/enhancedUserOrgApi';
import { FontFamily } from 'types/config';

const ThemeFontFamily = () => {
    const { fontFamily, onChangeFontFamily } = useConfig();
    const { data: preferences, isLoading: preferencesIsLoading } = useGetApiUserPreferencesParsedQuery();
    const [putPreferences] = usePutApiUserPreferencesMutation();

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newFontFamily = event.target.value as FontFamily;

        onChangeFontFamily(newFontFamily);

        putPreferences({
            body: {
                ...preferences,
                fontFamily: newFontFamily,
            },
        });
    };

    return (
        <FormControl>
            <FormLabel>Font Family</FormLabel>

            <RadioGroup value={fontFamily} onChange={handleRadioChange}>
                <FormControlLabel value={FontFamily.INTER} control={<Radio />} label='Inter' />
                <FormControlLabel value={FontFamily.POPPINS} control={<Radio />} label='Poppins' />
                <FormControlLabel value={FontFamily.ROBOTO} control={<Radio />} label='Roboto' />
                <FormControlLabel value={FontFamily.PUBLIC_SANS} control={<Radio />} label='Public Sans' />
                <FormControlLabel value={FontFamily.MAVEN_PRO} control={<Radio />} label='Maven Pro' />
            </RadioGroup>
            {preferencesIsLoading && <CircularProgress />}
        </FormControl>
    );
};

export default ThemeFontFamily;
